module.exports = __webpack_public_path__ + "img/icon6.2cc1c930.png";